<div class="demo-page saved-card-page sip-pay-page">
  <div class="layout">
    <div class="phone-column">
      <div class="phone-shell">
        <div class="phone-side-button phone-side-button--left"></div>
        <div class="phone-side-button phone-side-button--right"></div>

        <div class="phone-frame">
          <div class="phone-status-bar">
            <span class="status-time">{{ currentTimeLabel }}</span>
            <div class="status-notch" aria-hidden="true"></div>
            <div class="status-icons" aria-hidden="true">
              <span class="status-dot"></span>
              <span class="status-dot"></span>
              <span class="status-battery"></span>
            </div>
          </div>

          <div class="phone-screen">
            <header class="app-header">
              <div class="app-header-brand">
                <span class="app-logo sip-logo">S</span>
                <div>
                  <span class="app-title">App Sip</span>
                  <span class="app-subtitle">Server-to-server</span>
                </div>
              </div>
              <span class="app-badge">{{ selectedApiEnv }}</span>
            </header>

            <div class="screen-body" [ngSwitch]="appScreen">
              <div *ngSwitchCase="'form'" class="screen home-screen">
                <div class="hero-block">
                  <div class="hero-icon hero-icon--sip">
                    <ng-icon name="lucideSmartphone" size="28"></ng-icon>
                  </div>
                  <h2>Pago con Sip</h2>
                  <p>Authorize/sip sin SDK. El resultado llega al sipWebHook de OCC (webhook.site).</p>
                </div>

                <div class="sip-summary">
                  <div>
                    <small>Total</small>
                    <strong>{{ myForm.get('currencyCode')?.value }} {{ myForm.get('amount')?.value | number:'1.2-2' }}</strong>
                  </div>
                  <div>
                    <small>DNI / celular</small>
                    <strong>{{ myForm.get('documentNumber')?.value }} · {{ myForm.get('phone')?.value }}</strong>
                  </div>
                </div>

                <div class="screen-actions">
                  <button
                    mat-raised-button
                    color="primary"
                    class="app-btn app-btn--primary"
                    (click)="startSipPayment()"
                    [disabled]="isLoading">
                    <ng-icon [name]="isLoading ? 'lucideLoader2' : 'lucideSmartphone'" size="18" [class.console-btn__icon--spin]="isLoading"></ng-icon>
                    Pagar con Sip
                  </button>
                </div>
              </div>

              <div *ngSwitchCase="'waiting'" class="screen waiting-screen">
                <div class="waiting-visual">
                  <div class="waiting-ring waiting-ring--active">
                    <mat-spinner diameter="52"></mat-spinner>
                  </div>
                </div>
                <h3>Esperando confirmación</h3>
                <p>Abrí el simulador en otra pestaña y aprobá el pago.</p>
                <p class="sip-poll-hint">Escuchando: <strong>{{ waitingPollLabel }}</strong> (en local el dev server reenvía el poll; si falla, fallback GET orden cada 3 s).</p>
                <p class="sip-countdown">Tiempo restante (expiresAt): <strong>{{ waitingCountdownLabel }}</strong></p>
                <p class="sip-uid" *ngIf="uniqueIdentifier"><small>UID</small> {{ uniqueIdentifier }}</p>
                <div class="screen-actions screen-actions--stack">
                  <button mat-stroked-button class="app-btn app-btn--ghost" type="button" (click)="openSimulator()">
                    Simulador Agora
                  </button>
                  <button mat-stroked-button class="app-btn app-btn--ghost" type="button" (click)="openWebhookSite()">
                    Ver webhook.site
                  </button>
                </div>
              </div>

              <div *ngSwitchCase="'result'" class="screen result-screen">
                <div
                  class="result-visual"
                  [class.result-visual--success]="paymentResult?.success"
                  [class.result-visual--error]="!paymentResult?.success">
                  <ng-icon [name]="paymentResult?.success ? 'lucideCircleCheck' : 'lucideCircleX'" size="40"></ng-icon>
                </div>
                <h3>{{ paymentResult?.success ? '¡Pago exitoso!' : 'Pago no completado' }}</h3>
                <p class="result-message">{{ paymentResult?.message }}</p>
                <p *ngIf="paymentResult?.code" class="result-code">{{ paymentResult?.code }}</p>
                <p *ngIf="paymentResult?.source" class="result-code">Origen: {{ paymentResult?.source }}</p>

                <div class="screen-actions">
                  <button mat-raised-button color="primary" class="app-btn app-btn--primary" (click)="resetFlow()">
                    Nuevo pago
                  </button>
                </div>
              </div>
            </div>

            <div class="phone-home-indicator" aria-hidden="true"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="config-column">
      <div class="config-console">
        <h2 class="config-console__title">Pago con Sip</h2>
        <p class="config-console__subtitle">OCC + webhook.site · POST authorize/sip (order completo + browserParameters)</p>
        <p class="sip-hint">
          El <code>sipWebHook</code> debe estar en MerchantStore (OCC):
          <a [href]="webhookSiteUrl" target="_blank" rel="noopener noreferrer">{{ webhookSiteUrl }}</a>.
          El webhook solo se envía tras status-event o timeout en preprocessor.
        </p>
        <form [formGroup]="myForm" class="config-form">
          <app-console-section title="API">
            <div class="console-form-grid">
              <div class="console-field">
                <label class="console-field__label" for="sip-apiEnvironment">Ambiente API</label>
                <select id="sip-apiEnvironment" class="console-select" formControlName="apiEnvironment">
                  <option value="DEV">DEV — dev.api.epago.pe</option>
                  <option value="QA">QA — qas.api.epago.pe</option>
                  <option value="PRD">PRD — api.epago.pe</option>
                </select>
                <span class="console-field__hint">Endpoint: {{ selectedApiBaseUrl }}</span>
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sip-apiKey">API Key</label>
                <input id="sip-apiKey" class="console-input" formControlName="apiKey" />
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sip-secret">Secret</label>
                <input id="sip-secret" class="console-input" formControlName="secret" />
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sip-orderNumber">Número de orden</label>
                <input id="sip-orderNumber" class="console-input" formControlName="orderNumber" readonly />
              </div>
              <div class="console-field console-field--full">
                <label class="console-field__label" for="sip-webhookToken">Token webhook.site</label>
                <input id="sip-webhookToken" class="console-input" formControlName="webhookToken" />
                <span class="console-field__hint">UUID de la inbox OCC en webhook.site</span>
              </div>
            </div>
          </app-console-section>

          <app-console-section title="Comprador (Sip)">
            <div class="console-form-grid">
              <div class="console-field">
                <label class="console-field__label" for="sip-documentType">Tipo doc.</label>
                <select id="sip-documentType" class="console-select" formControlName="documentType">
                  <option value="DNI">DNI</option>
                  <option value="CE">CE</option>
                </select>
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sip-documentNumber">Número doc.</label>
                <input id="sip-documentNumber" class="console-input" formControlName="documentNumber" />
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sip-phone">Celular (9 dígitos)</label>
                <input id="sip-phone" class="console-input" formControlName="phone" />
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sip-amount">Monto</label>
                <input id="sip-amount" type="number" class="console-input" formControlName="amount" />
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sip-currencyCode">Moneda</label>
                <input id="sip-currencyCode" class="console-input" formControlName="currencyCode" />
              </div>
            </div>
          </app-console-section>
        </form>
        <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
      </div>
    </div>
  </div>
</div>
